export default function SvgPlay6() {
    return (
      <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32px"
      cursor="pointer"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M11.075 7.508c-1.329-.784-2.825.283-2.825 1.705v5.574c0 1.422 1.496 2.489 2.825 1.705l4.72-2.787c1.273-.752 1.273-2.658 0-3.41l-4.72-2.787zM9.75 9.213c0-.198.096-.337.21-.408a.323.323 0 01.352-.005l4.72 2.787a.465.465 0 01.218.413.465.465 0 01-.218.413l-4.72 2.787a.323.323 0 01-.353-.005.467.467 0 01-.209-.408V9.213z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75 22.75 17.937 22.75 12 17.937 1.25 12 1.25zM2.75 12a9.25 9.25 0 1118.5 0 9.25 9.25 0 01-18.5 0z"
        clipRule="evenodd"
      ></path>
    </svg>
   </>
  );
}
